/**
 * WordPress dependencies
 */
import { useState, useEffect } from '@wordpress/element';

/**
 * Internal dependencies
 */
import presetBlocksData from './blocks.json';
import BlockItem from './blockItem';
import { openNotification } from '../../../functions';

function Blocks() {
	const [isLoading, setIsLoading] = useState(false);
	const [isSingleBlockActive, setIsSingleBlockActive] = useState(null);
	const [inActiveBlocks, setInActiveBlocks] = useState(
		rv_dashboard_data.dashboardData?.inActiveBlocks || []
	);

	const isProActive = rv_dashboard_data?.isActive;
	const blockList = presetBlocksData.blocks_settings;
	const totalLiveBlock = blockList.filter((item) => item.status === 'live').length;

	// Update isSingleBlockActive when inActiveBlocks or totalLiveBlock changes
	useEffect(() => {
		const _isSingleBlock = totalLiveBlock - inActiveBlocks.length === 1;
		setIsSingleBlockActive(_isSingleBlock);
	}, [inActiveBlocks, totalLiveBlock]);

	const handleToggleNew = (value, name) => {
		let updatedInActiveBlocks;

		if (value) {
			updatedInActiveBlocks = inActiveBlocks.filter((item) => item !== name);
		} else {
			updatedInActiveBlocks = [...inActiveBlocks, name];
		}

		setInActiveBlocks(updatedInActiveBlocks);

		// Prepare updated dbData
		const updatedDbData = {
			...rv_dashboard_data.dashboardData,
			inActiveBlocks: updatedInActiveBlocks,
		};

		setIsLoading(true);

		// Pass data to the API
		wp.apiFetch({
			path: '/rio-vizual/v2/save_dashboard_blocks',
			method: 'POST',
			data: {
				dashboard_data: updatedDbData,
			},
		})
			.then((res) => {
				openNotification('success', 'Data Saved Successfully!', 'Your changes have been saved.');
			})
			.catch((error) => {
				openNotification('error', 'Failed to Save Data', 'Please try again.');
				// Rollback state if API call fails
				setInActiveBlocks(inActiveBlocks);
			})
			.finally(() => {
				setIsLoading(false);
			});
	};

	return (
		<>
			{isLoading && <div className="rv_dash-loader" /> }

			<div className="rv_dash-blocks-page">
				<div className="rv_dash-block-items">
					{blockList.map((block, index) => {
						const isInactiveBlock = inActiveBlocks.includes(block.name) || false;
						return (
							<BlockItem
								key={index}
								block={block}
								isInactiveBlock={isInactiveBlock}
								isProActive={isProActive}
								isSingleBlockActive={isSingleBlockActive}
								handleToggle={(value, name) => handleToggleNew(value, name)}
							/>
						);
					})}
				</div>
			</div>
		</>

	);
}

export default Blocks;
